export const DS_FORM_CLASSES = {
  Root: "ds-form",
  Errors: "ds-form__errors",
  Actions: "ds-form__actions",
  SubmitActions: "ds-form__submit-actions",
} as const;
